module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 39
// module chunks = 168707334958949